let INFO = [
  {
    title: '<b>Utwory muzyczne</b>',
    index: [
      '• Piosenki: Przywitanie, <i>Oto ja, Smocza ballada</i>',
      ' Słowa: <i>Radosław Ragan</i>',
      ' Muzyka: <i>Magdalena Ziółkowska</i>',
      ' Aranżacje muzyczne: <i>Marek Rusinowski</i>',
      ' Śpiewa: Zespół wokalno-taneczny ETIUDA z Państwowej Szkoły Muzycznej I i II stopnia w Gliwicach',
      ' Studio nagrań: HH Poland',
      ' Realizacja nagrań: Grzegorz Gutowski ',
    ],
  },
  {
    index: [
      '• Słuchowisko <i>Odgłosy ptaków</i>',
      ' Studio nagrań: United Records Studio',
      ' Realizacja nagrań: United Records Studio',
    ],
  },
];

export default INFO;
